import { render, staticRenderFns } from "./JournalSectionTreeItems.vue?vue&type=template&id=222c5a88&scoped=true&"
import script from "./JournalSectionTreeItems.vue?vue&type=script&lang=js&"
export * from "./JournalSectionTreeItems.vue?vue&type=script&lang=js&"
import style0 from "./JournalSectionTreeItems.vue?vue&type=style&index=0&id=222c5a88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c5a88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
